<template>
  <div class="main-container" v-if="!loading">
    <MultiRoomDisplay if="customer" v-if="isRoomDisplayMultiRoomVersionActive" />
    <RoomRateDisplay if="customer" v-else-if="loadRateDisplay" />
    <RoomDisplay if="customer" v-else />
  </div>
</template>

<script>

import Customer from '@/domain/Customer'
import { isNewRoomDisplayActive, isRoomDisplayMultiRoomVersionActive } from '@/infrastructure/Configuration'
import { experienceRoomRateDisplay } from '@/room-rate-display/infrastructure/Factory'

export default {
  components: {
    RoomDisplay: () => import('@/room-display/RoomDisplayView'),
    RoomRateDisplay: () => import('@/room-rate-display/RoomDisplayView'),
    MultiRoomDisplay: () => import('@/multi-room-display/RoomDisplayView')
  },
  data: () => ({
    customer: null,
    loadRateDisplay: false,
    isNewRoomDisplayActive: isNewRoomDisplayActive(),
    isRoomDisplayMultiRoomVersionActive: isRoomDisplayMultiRoomVersionActive(),
    loading: true
  }),
  async created () {
    // eslint-disable-next-line
    global.$(window).on('auth.logged auth.postlogged', (event, data) => {
      this.customer = Customer.fromJSON(data)
      this.$store.dispatch('setCustomer', data)
    })
    global.$(window).on('auth.nologged', () => {
      this.customer = Customer.anonymous()
      this.$store.dispatch('revomeCustomer')
    })
    const isQubitDefaultRoomDisplay = await experienceRoomRateDisplay.showDefaultRoomDisplay()
    // if FF NEW-RD is TRUE AND QUBIT Experience is ENABLED -> QBUIT decide the version of RD is shown
    if (this.isNewRoomDisplayActive && isQubitDefaultRoomDisplay !== undefined) {
      this.loadRateDisplay = !isQubitDefaultRoomDisplay
    // if FF NEW-RD is TRUE -> Always NEW RD is shown
    } else if (this.isNewRoomDisplayActive) {
      this.loadRateDisplay = true
    // if FF NEW-RD is FALSE -> Always OLD RD is shown
    } else {
      this.loadRateDisplay = false
    }

    console.log('RD VERSION: ', this.isRoomDisplayMultiRoomVersionActive ? 'MULTIROOM (V3)' : (this.loadRateDisplay ? 'GROUPS (V2)' : 'STAYS (V1)'))
    this.loading = false
  }

}
</script>

<style lang="scss" scoped>
.main-container {
  min-height: 700px;
}
</style>
